 <template>
 	<div id="mid-map" class="mid-map">
		<div class="mid-map_title">
			阳光玫瑰数据中心
		</div>
 		<div class="map" id="map">
 		</div>
 		<div class="map_text map_text1">
 			<div class="text_title1">发强农场</div>
 			<p class="text_contain">{{
			`永康市唐先镇发强家庭农场成立于2009年4月2日，
			注册地位于浙江省金华市永康市唐先镇夏杜曹村西田畈,
			经营者为曹发强，经营范围包括白酒加工（具体经营项
			目详见《食品生产经营登记证》）果树种植（不含种苗）
			、销售（依法须经批准的项目，经相关部门批准后方可
			开展经营活动`}}</p>

 		</div>
 		<div class="map_text2">
 			<div class="text_title2">阳光玫瑰葡萄</div>
 			<p class="text_contain">{{`阳光玫瑰葡萄，是葡萄科葡萄属植物。
 				其根系发达；嫩梢绿色、无绒毛、新梢嫩尖叶多为浅白色，
 				带绒毛，新梢成熟后为黄褐色；叶片大，扇形中厚；两性花，果
 				肉较软，有浓郁的玫瑰香味；三月上旬萌芽，五月上旬开花；八
 				月中旬果实开始成熟。阳光玫瑰葡萄因果实含糖量较高，果
 				肉鲜脆多汁，鲜食品质极优，有玫瑰香味，故名阳光玫瑰。`}}</p>
 		</div>
		<div class="map_text3_open">
			<img src="@/assets/home/mid-map/line.png" @click="show = !show" alt="" />
		</div>
		<transition name="el-zoom-in-left">
		      <div class="map_text3" v-show="show">
		      	<hitory/>
		      </div>
		</transition>
 	</div>
 </template>
 <script setup>
 	import {
 		ref,
 		onMounted,
 		onBeforeUnmount
 	} from "vue";
 	import * as echarts from "echarts";
	import hitory from "../mid-map/history/index.vue";
 	// 引入中国地图的 JSON 数据，这里以 echarts-countries-pyp 的数据为例
 	import chinaGeoJSON from "@/assets/js/Yongkang.js";
	const show = ref(true)

 	function init() {
 		const ratio = (val) => {
 			return window.screen.width * val / 1980;
 		}
 		const option = {
 			geo: [{
 					map: 'huizhou',
 					aspectScale: 0.9,
 					roam: false, //是否允许缩放
 					//zoom: 1.1, //默认显示级别
 					layoutSize: '90%',
 					layoutCenter: ['49.5%', '58	%'],
 					itemStyle: {
 						areaColor: '#066953',
 						borderColor: '#066953',
 						borderWidth: 1,
 					},
 					// zlevel: 1,
 					silent: true,
 				},
 				{
 					map: 'huizhou',
 					aspectScale: 0.9,
 					roam: false, //是否允许缩放
 					//zoom: 1.1, //默认显示级别
 					layoutSize: '92%',
 					layoutCenter: ['49.5%', '55%'],
 					itemStyle: {
 						areaColor: {
 							type: 'radial',
 							x: 0.7,
 							y: 0.5,
 							r: 0.4,
 							colorStops: [{
 								offset: 0,
 								color: '#066953' // 0% 处的颜色
 							}, {
 								offset: 1,
 								color: '#066953' // 100% 处的颜色
 							}],
 							global: false // 缺省为 false
 						},
 						borderColor: '#72aa9e',
 						borderWidth: 2,
 						//选中效果
 						emphasis: {
 							areaColor: "#166553", // hover效果
 						},
 					},
 					// zlevel: 2,
 					silent: false,


 				},
 			],
 			series: [{
 				name: '目标点',
 				type: "effectScatter",
 				// 使用高德地图坐标系
 				coordinateSystem: "geo",
 				// 数据格式跟在 geo 坐标系上一样，每一项都是 [经度，纬度，数值大小，其它维度...]
 				data: [{
 					name: '永康市发强家庭农场',
 					value: [120.103398, 29.000355]
 				}],
 				symbolSize: 8,
 				encode: {
 					value: 2
 				},
 				rippleEffect: {
 					//涟漪特效
 					period: 4, //动画时间，值越小速度越快
 					brushType: 'stroke', //波纹绘制方式 stroke, fill
 					scale: 6, //波纹圆环最大限制，值越大波纹越大
 				},
 				label: {
 					normal: {
 						formatter: '{b}',
 						position: 'right',
 						show: true
 					},
 					// emphasis: {
 					// 	show: true
 					// }
 				},
 				itemStyle: {
 					normal: {
 						color: 'rgba(255, 255, 127, 0.8)'
 					}
 				}
 			}]

 		}
 		// 让  指定id 的 div 的_echarts_instance_属性值 为 空状态
 		document.getElementById("map").removeAttribute('_echarts_instance_');
 		let chart = echarts.init(document.getElementById("map"));
 		//地图组件
 		echarts.registerMap("huizhou", chinaGeoJSON);
 		chart.setOption(option);
 	}
 	onMounted(() => {
 		init()

 	})
 </script>
 <style scoped lang="scss">
 	.mid-map {
 		width: 992px;
 		margin: 0 auto;
 		height: 800px;
 		background-image: url('../../../assets/home/mid-map/mid_boder.png');
 		margin-top: 15px;
 		position: relative;
		.mid-map_title{
			height: 40px;
			color: #2dffd0;
			font-size: 16px;
			line-height: 40px;
			padding-left: 10px;
			width: 90%;
			background-image: url('../../../assets/home/mid-map/midtitle.png');
		}
 	}

 	.map {
 		margin-top: 50px;
 		width: 98%;
 		margin-left: 1%;
 		height: 430px;
 		z-index: 1;
 	}

 	.map_text2 {

 		position: absolute;
 		top: 60px;
 		right: 10px;
 		width: 280px;
 		background-image: url("../../../assets/home/mid-map/mid_boder.png");
 		background-size: 280px 100%;

 		.text_title2 {
 			height: 28px;
 			width: 266px;
 			color: #2dffd0;
 			margin-left: 10px;
 			padding-left: 150px;
 			padding-top: 5px;
 			margin-top: 10px;
 			background-image: url("../../../assets/home/mid-map/map_title_right.png");
 			background-size: 266px 28px;
 			background-repeat: no-repeat;
 		}


 		p {
 			text-indent: 2em;
 			/* 设置首行缩进为两个字符 */
 			line-height: 20px;
 			color: #669692;
 			padding-bottom: 20px;
 		}
 	}

 	.map_text1 {
 		position: absolute;
 		top: 60px;
 		left: 20px;
 		width: 280px;
 		background-image: url("../../../assets/home/mid-map/mid_boder.png");
 		background-size: 100% 100%;

 		.text_title1 {
 			height: 28px;
 			width: 266px;
 			color: #2dffd0;
 			margin-left: 10px;
 			padding-left: 30px;
 			padding-top: 5px;
 			margin-top: 10px;
 			background-image: url("../../../assets/home/mid-map/map_title.png");
 			background-size: 266px 28px;
 			background-repeat: no-repeat;
 		}


 		p {
 			text-indent: 2em;
 			/* 设置首行缩进为两个字符 */
 			line-height: 20px;
 			color: #669692;
 			padding-bottom: 20px;
 		}
 	}

    .map_text3_open{
		
		position: absolute;
		bottom: 240px;
		left: 20px;
		height:20px;
		width:20px;
		
		img{
			height:20px;
			width:20px;
		}
	}
	
 	.map_text3 {
 		position: absolute;
 		bottom: 20px;
 		left: 46px;
 		width: 900px;
 		height: 230px;
 		text-align: center;
 		font-size: 16px;
 		color: #2dffd0;
 		padding-top: 10px;
 		background-image: url("@/assets/home/24.png");
 		background-size: 100% 100%;

 		}

 	.background-image_button {
 		background-image: url("../../../assets/home/button.png");
		background-size: 100% 100%;
		color: white;
 	}
 </style>